import type { Article } from "@/mocks/articles";

export default function ArticleBody({ article }: { article: Article }) {
  return (
    <div className="mt-10">
      {article.content.map((block, index) => {
        if (block.type === "h") {
          return (
            <h2
              key={`block-${index}`}
              className="mb-3 mt-9 flex items-center gap-3 font-heading text-lg font-bold text-foreground-950 md:text-xl"
            >
              <span className="h-4 w-1 flex-none bg-primary-500"></span>
              {block.text}
            </h2>
          );
        }

        if (block.type === "quote") {
          return (
            <blockquote
              key={`block-${index}`}
              className="my-7 border-l-2 border-accent-500 bg-accent-50 px-5 py-4 font-heading text-sm leading-relaxed text-accent-900 md:text-base"
            >
              {block.text}
            </blockquote>
          );
        }

        if (block.type === "list") {
          return (
            <ul key={`block-${index}`} className="my-5 space-y-2.5">
              {(block.items ?? []).map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                  <span className="mt-2 flex h-1.5 w-1.5 flex-none rounded-full bg-secondary-500"></span>
                  {item}
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p
            key={`block-${index}`}
            className="my-4 text-sm leading-[1.9] text-foreground-700 md:text-base"
          >
            {block.text}
          </p>
        );
      })}
    </div>
  );
}